exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".screenfull-svg[data-v-29234bee] {\n  display: inline-block;\n  cursor: pointer;\n  fill: #5a5e66;\n  width: 0.104167rem;\n  height: 0.104167rem;\n  vertical-align: 0.052083rem;\n}", ""]);

// exports
